module.exports = __webpack_public_path__ + "fa5e142e9f76edc1fa42d3c1587a649c.svg";